import { render, staticRenderFns } from "./TemplateDetailCard.vue?vue&type=template&id=1043be7f&scoped=true&"
import script from "./TemplateDetailCard.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailCard.vue?vue&type=style&index=0&id=1043be7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1043be7f",
  null
  
)

export default component.exports